import { render, staticRenderFns } from "./ClubSelector.vue?vue&type=template&id=1c035c54&"
import script from "./ClubSelector.vue?vue&type=script&lang=js&"
export * from "./ClubSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports